import React, { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Icon } from 'assets/icons';
import { useFileService } from 'hooks/api/files/file';
import styles from './announcements.module.css';

const MAX_FILE_SIZE_MB = 5;

export const ImageUploadField = ({ value = '', onChange = () => {}, label = 'Image' }) => {
  const { uploadImage } = useFileService();
  const file_input_ref = useRef(null);
  const [file_name, setFileName] = useState('');
  const [uploading, setUploading] = useState(false);
  const [dragging, setDragging] = useState(false);

  const uploadFile = async (file) => {
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      toast.error('Only image files are allowed.');
      return;
    }

    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      toast.error(`Image must be smaller than ${MAX_FILE_SIZE_MB}MB.`);
      return;
    }

    setUploading(true);
    const data = new FormData();
    data.append('image', file);
    const payload = await uploadImage({ data });
    setUploading(false);

    if (!payload) return;
    setFileName(file.name);
    onChange(payload.location);
  };

  const handleFileSelect = (e) => {
    uploadFile(e.target.files[0]);
    e.target.value = null;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    uploadFile(e.dataTransfer.files[0]);
  };

  const handleRemove = () => {
    setFileName('');
    onChange('');
  };

  return (
    <div className={styles.uploadField}>
      <label>{label}</label>
      <input
        ref={file_input_ref}
        type="file"
        accept="image/*"
        className={styles.hiddenInput}
        onChange={handleFileSelect}
      />
      <div
        className={`${styles.dropzone} ${dragging ? styles.dropzoneActive : ''}`}
        onClick={() => !uploading && file_input_ref.current.click()}
        onDragOver={(e) => {
          e.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={handleDrop}
      >
        <Icon name="upload" width={18} height={18} />
        <span className={styles.dropzoneText}>
          {uploading
            ? 'Uploading…'
            : file_name || value
            ? file_name || 'Image uploaded'
            : 'Click or drop an image here'}
        </span>
      </div>
      {value && (
        <div className={styles.previewWrapper}>
          <img src={value} alt="Announcement preview" className={styles.previewImage} />
          <span className={styles.removePreview} onClick={handleRemove}>
            <Icon name="close" width={12} height={12} />
          </span>
        </div>
      )}
    </div>
  );
};
